export enum LibrariesRoutePathNames {
  LIST = '',
  LIBRARIES = 'libraries',
  CPG_ITEMS_LIST = 'consumer-packaged-goods',
  VERIFIED_ITEMS = 'verified',
  PENDING_ITEMS = 'pending',
}
